var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { lifecycle } from "vscode-lib";
/**
 * TODO: possible to replace with matrixClient maySendMessage / maySendEvent?
 *
 * Keeps track of Members in a room with write access
 *
 * Use hasWriteAccess to validate whether a user has write access to the room.
 *
 * A MatrixMemberReader keeps track of users and permissions by
 * retrieving and monitoring m.room.member and m.room.power_levels information
 */
export class MatrixMemberReader extends lifecycle.Disposable {
    constructor(matrixClient, reader) {
        super();
        this.matrixClient = matrixClient;
        this.reader = reader;
        this.disposed = false;
        this.initialized = false;
        this.initializing = false;
        this.initializeOutdated = false;
        this.members = new Map();
        this.processEvent = (event) => {
            if (event.type !== "m.room.power_levels" &&
                event.type !== "m.room.member") {
                return;
            }
            if (this.initializing) {
                this.initializeOutdated = true;
                return;
            }
            if (!this.initialized) {
                return;
            }
            if (event.type === "m.room.power_levels") {
                this.powerLevels = event.content;
                // TODO: test
                return;
            }
            if (event.type === "m.room.member") {
                if (event.content.membership === "join") {
                    const member = {
                        displayname: event.content.displayname,
                        user_id: event.user_id,
                    };
                    this.members.set(event.user_id, member);
                }
                else {
                    this.members.delete(event.user_id);
                }
                return;
            }
            throw new Error("unexpected");
        };
        this._register(this.reader.onEvents((e) => e.events.forEach((e) => this.processEvent(e))));
    }
    hasWriteAccess(user_id, event_type = "m.room.message") {
        if (!this.members.has(user_id)) {
            return false;
        }
        const levels = this.powerLevels;
        let requiredLevel = levels.events[event_type];
        if (requiredLevel === undefined) {
            requiredLevel = levels.events_default;
        }
        let userLevel = levels.users[user_id];
        if (userLevel === undefined) {
            userLevel = levels.users_default;
        }
        if (typeof userLevel !== "number" || typeof requiredLevel !== "number") {
            throw new Error("unexpected");
        }
        return userLevel >= requiredLevel;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initializing || this.initialized) {
                throw new Error("already initializing / initialized");
            }
            if (!this.reader.isStarted) {
                throw new Error("MatrixReader must have started before initializing MatrixMemberReader");
            }
            this.initializing = true;
            const [powerLevels, members] = yield Promise.all([
                this.matrixClient.getStateEvent(this.reader.roomId, "m.room.power_levels"),
                this.matrixClient.members(this.reader.roomId, ["join"]),
            ]);
            if (this.initializeOutdated) {
                // A power_levels or member event has been received in the mean time.
                // Simplest (but inefficient) way to make sure we're consistent in this edge-case
                // is to reinitialize
                this.initializing = false;
                this.initializeOutdated = false;
                return this.initialize();
            }
            this.powerLevels = powerLevels;
            members.chunk
                .filter((e) => e.type === "m.room.member" && e.content.membership === "join")
                .forEach((e) => {
                this.members.set(e.user_id, {
                    displayname: e.content.displayname,
                    user_id: e.user_id,
                });
            });
            this.initializing = false;
            this.initialized = true;
        });
    }
    dispose() {
        this.disposed = true;
        super.dispose();
    }
}
//# sourceMappingURL=MatrixMemberReader.js.map